<template>
  <client-only>
    <div>
      <v-container
        id="companies-section"
        class="mb-12 px-0 pt-0"
        v-if="this.$vuetify.breakpoint.mdAndUp"
      >
        <v-layout
          class="section_inner"
          align-center
          column
          justify-space-around
          text-center
          wrap
          style="background-color: #f6f7f9"
          pb-5
        >
          <v-flex>
            <h3 class="display-36 primary--text text-center mt-2 mb-2">
              {{ isHitech ? titleHitech : titleAll }}
            </h3>
          </v-flex>
          <v-flex
            v-for="(i, key) in dfpPage"
            :key="key"
            text-center
            class="company-item"
            d-flex
            mb--4
            mt-2
          >
            <GptAd
              flex-grow
              :ad-unit="`3177829/${i.adunit}`"
              :id="i.id"
              :size="[120, 38]"
            />
          </v-flex>
        </v-layout>
        <v-layout colomun wrap my-12>
          <v-flex>
            <a href="#">
              <client-only>
                <GptAd
                  :ad-unit="dfpBig1.adunit"
                  :id="dfpBig1.id"
                  :size="[300, 990]"
                  :size-mapping="[
                    [
                      [1024, 768],
                      [300, 990],
                    ],
                    [
                      [980, 690],
                      [300, 990],
                    ],
                    [
                      [640, 480],
                      [300, 990],
                    ],
                    [
                      [0, 420],
                      [300, 990],
                    ],
                  ]"
                />
              </client-only>
            </a>
          </v-flex>
        </v-layout>

        <!-- dfpPage2 -->
        <v-layout
          v-if="displayBanner"
          class="section_inner"
          align-center
          column
          justify-space-around
          text-center
          wrap
          style="background-color: #f6f7f9"
          pb-5
        >
          <v-flex>
            <h3 class="display-36 primary--text text-center mt-2 mb-2">
              {{ isHitech ? titleHitech : titleAll }}
            </h3>
          </v-flex>
          <v-flex
            v-for="(i, key) in dfpPage2"
            :key="key"
            text-center
            class="company-item"
            d-flex
            mb--4
            mt-2
          >
            <GptAd
              flex-grow
              :ad-unit="`3177829/${i.adunit}`"
              :id="i.id"
              :size="[120, 38]"
            />
          </v-flex>
        </v-layout>
        <!-- dfpBig2 -->
        <v-layout v-if="displayBanner" colomun wrap my-12>
          <v-flex>
            <a href="#">
              <client-only>
                <GptAd
                  :ad-unit="dfpBig2.adunit"
                  :id="dfpBig2.id"
                  :size="[300, 990]"
                  :size-mapping="[
                    [
                      [1024, 768],
                      [300, 990],
                    ],
                    [
                      [980, 690],
                      [300, 990],
                    ],
                    [
                      [640, 480],
                      [300, 990],
                    ],
                    [
                      [0, 420],
                      [300, 990],
                    ],
                  ]"
                />
              </client-only>
            </a>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </client-only>
</template>

<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';

export default {
  props: {
    isHitech: {
      type: Boolean,
      required: false,
      default: false,
    },
    catCode: {
      type: Number,
      required: false,
      default: null,
    },
    page: {
      type: String,
      required: false,
      default: 'jobPage',
    },
    articleLength: {
      type: Number,
      required: false,
      default: 0,
    },
    limitSideBanners: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      hitechPage: false,
      title: '',
      titleAll: t`titles.leadingCompanies`,
      titleHitech: t`titles.leadingCompaniesHitech`,
      dfpSideBig1: {
        adunit: '3177829/DRUSHIM-SIDE-NEW-300',
        id: '1603262806388-0',
      },
      dfpSideBig2: {
        adunit: '3177829/DRUSHIM-SIDE-NEW2-300-990',
        id: '1603267920137-0',
      },

      dfpSideBigHiTech1: {
        adunit: '3177829/DRUSHIM_SIDE_NEW_TECH_300',
        id: '1603262667088-0',
      },
      dfpSideBigHiTech2: {
        adunit: '3177829/DRUSHIM_SIDE_NEW_TECH2_300',
        id: '1603262564026-0',
      },

      regPage: {
        1: {
          adunit: 'Logo1newsite',
          id: '1585493459494-0',
        },
        2: {
          adunit: 'Logo2newsite',
          id: '1585493765398-0',
        },
        3: {
          adunit: 'Logo3newsite',
          id: '1585493850505-0',
        },
        4: {
          adunit: 'Logo4newsite',
          id: '1585494035449-0',
        },
        5: {
          adunit: 'Logo5newsite',
          id: '1585494121594-0',
        },
        6: {
          adunit: 'Logo6newsite',
          id: '1585494224909-0',
        },
      },
      regPage2: {
        1: {
          adunit: 'Logo7newsite',
          id: '1601569715877-0',
        },
        2: {
          adunit: 'Logo8newsite',
          id: '1601569905499-0',
        },
        3: {
          adunit: 'Logo9newsite',
          id: '1601569994971-0',
        },
        4: {
          adunit: 'Logo10newsite',
          id: '1601570051091-0',
        },
        5: {
          adunit: 'Logo11newsite',
          id: '1601570118302-0',
        },
        6: {
          adunit: 'Logo12newsite',
          id: '1601570186392-0',
        },
      },
      hightechPage: {
        1: {
          adunit: 'Logo1hightechnew',
          id: '1585497146807-0',
        },
        2: {
          adunit: 'Logo2hightechnew',
          id: '1585497199259-0',
        },
        3: {
          adunit: 'Logo3hightechnew',
          id: '1585497244150-0',
        },
        4: {
          adunit: 'Logo4hightechnew',
          id: '1585497290105-0',
        },
        5: {
          adunit: 'Logo5hightechnew',
          id: '1585497345889-0',
        },
        6: {
          adunit: 'Logo6hightechnew',
          id: '1585497394199-0',
        },
      },
      hightechPage2: {
        1: {
          adunit: 'Logo7hightechnew',
          id: '1601570693131-0',
        },
        2: {
          adunit: 'Logo8hightechnew',
          id: '1601570730290-0',
        },
        3: {
          adunit: 'Logo9hightechnew',
          id: '1601570762749-0',
        },
        4: {
          adunit: 'Logo10hightechnew',
          id: '1601571073863-0',
        },
        5: {
          adunit: 'Logo11hightechnew',
          id: '1601571105737-0',
        },
        6: {
          adunit: 'Logo12hightechnew',
          id: '1601571146691-0',
        },
      },
    };
  },
  computed: {
    displayBanner() {
      if (this.limitSideBanners) {
        return this.articleLength > 3800;
      } else {
        return true;
      }
    },
    // company logos
    dfpPage() {
      if (this.isHitech) {
        return this.hightechPage;
      } else {
        return this.regPage;
      }
    },
    dfpPage2() {
      if (this.isHitech) {
        return this.hightechPage2;
      } else {
        return this.regPage2;
      }
    },
    // DFP side big
    dfpBig1() {
      if (this.isHitech) {
        return this.dfpSideBigHiTech1;
      } else {
        return this.dfpSideBig1;
      }
    },
    dfpBig2() {
      if (this.isHitech) {
        return this.dfpSideBigHiTech2;
      } else {
        return this.dfpSideBig2;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#companies-section .v-card {
  box-shadow: none;
}

#companies-section .company-item {
  width: 85%;
  height: 80px;
  background-color: #fff !important;
  flex-shrink: 0;
  flex-basis: auto;
  place-items: center;
  border: 1px solid #dedfe0;
}

#companies-section .company-image {
  align-self: center;
}

#companies-section .company-jobs {
  align-self: center;
}

#companies-section .companies-all button {
  margin-top: -25px;
}

.company-img {
  max-width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 1280px) {
  #companies-section .company-item {
    height: 70px;
  }
}
</style>
